import React from "react";
import { Modal } from "react-bootstrap"; // Make sure to import Modal from react-bootstrap
import { useLocation, useNavigate } from "react-router-dom";
import BoatHelmW from "../../Asset/icon/boat_helm_w.svg";
import Rope_w from "../../Asset/icon/rope_w.svg";
import Close_x from "../../Asset/icon/closeButton.svg";
import Rubber from "../../Asset/icon/rubber.svg";
import { useTranslation } from "react-i18next";

function ModalPage({ show, onHide }) {
  const { t } = useTranslation();

  const bodyContainer = {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    zIndex: 500000,
  };
  const linkStyles = {
    display: "flex",
    width: "100%",
    justifyContent: "space-around",
    cursor: "pointer",
    zIndex: 500000,
  };

  const pageLinks = {
    Home: "/home",
    Destination: "/destination",
    Yacht: "/yacht",
    "Contact us": "/contact",
    "Become a Partner": "/become-a-partner",
  };

  const WithStyles = ({ headline }) => {
    const location = useLocation();
    const navigate = useNavigate();

    // Use the pageLinks mapping to find the corresponding URL path
    const pageLink = pageLinks[headline];

    const isCurrentPage = location.pathname
      .toLowerCase()
      .includes(pageLink.toLowerCase());

    const handleClick = () => {
      if (!isCurrentPage) {
        navigate(pageLink);
      } else if (
        location.pathname.toLowerCase().startsWith(pageLink.toLowerCase())
      ) {
        // Clear localStorage and reload if on the current page
        navigate(pageLink);
        localStorage.removeItem("Trip");
        localStorage.removeItem("Destination");
        localStorage.removeItem("selectedDate");
        window.location.reload(true); // Force refresh
        onHide();
      } else {
        onHide();
        window.history.replaceState(
          {},
          document.title,
          window.location.pathname
        ); // Clear query parameters
        window.location.reload(true); // Force refresh
      }
    };

    return (
      <div
        className={`modal-body-container ${isCurrentPage ? "visible" : "hidden"
          }`}
        style={bodyContainer}
      >
        <div onClick={handleClick} style={linkStyles}>
          <img
            draggable={false}
            className="Rubber"
            src={Rubber}
            alt="Rubber"
            style={{ visibility: isCurrentPage ? "visible" : "hidden" }}
          />
          <h4 className="fmp-1">{t(headline)}</h4>
          <img
            draggable={false}
            className="Rubber"
            src={Rubber}
            alt="Rubber"
            style={{ visibility: isCurrentPage ? "visible" : "hidden" }}
          />
        </div>
      </div>
    );
  };

  return (
    <div>
      <Modal
        show={show}
        fullscreen
        onHide={onHide}
        style={{ paddingRight: "0" }}
      >
        <img
          src={Close_x}
          alt="CloseBtn"
          onClick={onHide}
          className="abs-top-right-box"
        />
        <Modal.Header className="mt-10vh no-border-bottom">
          <img
            src={BoatHelmW}
            alt="BoatHelmW"
            draggable={false}
            style={{ width: "15vh" }}
          />
        </Modal.Header>
        <Modal.Body
          className="flex-col-evenly-center"
        >
          <WithStyles headline="Home" />
          <WithStyles headline="Destination" />
          <WithStyles headline="Yacht" />
          <WithStyles headline="Contact us" />
          <WithStyles headline="Become a Partner" />
        </Modal.Body>
        <Modal.Footer className="mb-10vh no-border-top">
          <img
            src={Rope_w}
            alt="Rope_w"
            draggable={false}
            className="w-15vh"
          />
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default ModalPage;
